import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getOneCmsLoungeFinderImagesBaseUrl } from '@/selectors/oneCmsSelectors';
import { useCommonContent } from '@/hooks/oneCmsIntlHooks/oneCmsIntlHelperHooks';
import { getLastViewedProduct } from '@/selectors/lastViewedProductSelectors';
import { Card } from '@/constants';

import LFLink from '../common/LFLink';

const GlobalLoungeCollectionBanner = () => {
  const [isHydrated, setIsHydrated] = useState(false);
  const {
    centurionNetwork: { globalLoungeCollectionBanner = {} },
  } = useCommonContent();
  const cmsImgBaseUrl = useSelector(getOneCmsLoungeFinderImagesBaseUrl);
  const lastViewedProduct = useSelector(getLastViewedProduct);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  if (!isHydrated || lastViewedProduct === Card.Delta) {
    return null;
  }

  const glcBannerImages = [
    { size: 'max', bp: { min: 1440 } },
    { size: 'xl', bp: { min: 1280, max: 1439 } },
    { size: 'lg', bp: { min: 1024, max: 1279 } },
    { size: 'medium', bp: { min: 800, max: 1023 } },
    { size: 'mobile', bp: { max: 799 } },
  ];

  return (
    <div className="tw-rounded-2xl tw-border tw-border-gray-300 tw-bg-gray-100 md_tw-inline-grid md_tw-w-full md_tw-grid-cols-3 md_tw-gap-10 md_tw-p-16">
      <div className="tw-h-47dot5 tw-content-center tw-justify-items-center tw-px-16 md_tw-h-full md_tw-border-r md_tw-border-gray-400 md_tw-px-0 md_tw-pr-10">
        <picture>
          {glcBannerImages.map(({ size, bp }) => {
            const minWidth = bp.min ? `(min-width: ${bp.min}px)` : '';
            const maxWidth = bp.max ? `(max-width: ${bp.max}px)` : '';
            const mediaQuery = [minWidth, maxWidth]
              .filter(Boolean)
              .join(' and ');

            return (
              <source
                key={size}
                srcSet={`${cmsImgBaseUrl}global-lounge-collection-logo-dark-font-${size}.svg`}
                media={mediaQuery}
              />
            );
          })}
          <img
            src={`${cmsImgBaseUrl}global-lounge-collection-logo-dark-font.svg`}
            alt="Global Lounge Collection Banner"
          />
        </picture>
      </div>
      <div className="tw-px-6 md_tw-hidden">
        <div className="tw-border-b-none tw-border-b tw-border-gray-400 md_tw-border-l" />
      </div>
      <div className="tw-col-span-2 tw-row-span-1 tw-gap-6 tw-p-6 md_tw-flex md_tw-flex-col md_tw-p-0">
        <div className="tw-col-span-2 tw-flex tw-flex-col tw-gap-1 tw-pb-4 md_tw-pb-0">
          <h3 className="tw-heading-md-medium tw-text-gray-900">
            {globalLoungeCollectionBanner?.title}
          </h3>
          <p className="tw-text-sm tw-text-gray-700">
            {globalLoungeCollectionBanner?.description}
          </p>
        </div>
        <div>
          <LFLink
            to={lastViewedProduct}
            className="btn primary btn-primary tw-w-full tw-max-w-none md_tw-w-auto"
          >
            {globalLoungeCollectionBanner?.ctaText}
          </LFLink>
        </div>
      </div>
    </div>
  );
};

export default GlobalLoungeCollectionBanner;
